import { jsx } from 'react/jsx-runtime';
import { UserContained, UserOutlined } from '@sgcmpteltd/uikit-react';

const MemberStatus = ({ isLogin, size, className, mobileIcon, }) => {
    const IconComponent = isLogin ? UserContained : UserOutlined;
    if (mobileIcon) {
        return (jsx("img", { alt: "user", height: "24", src: "https://i.i-sgcm.com/mobile/sidebar/user.svg", width: "24" }));
    }
    return (jsx(IconComponent, { className: className, size: size }));
};

export { MemberStatus as M };
//# sourceMappingURL=component-BlaoJfVJ.js.map
